export const adentisMenuConfig = {
  additionalItems: [
    // Example: Adentis might have a Projects menu
    // {
    //   key: "adentis-projects",
    //   icon: <Briefcase />,
    //   label: "Projects",
    //   route: { path: "/projects", key: "projects" },
    //   roles: "Manager,Admin",
    // },
  ],

  hideItems: [
    //Example: Adentis might have to hide the menu items
    // AppRoutes.whatsappGroupList.key,
    // AppRoutes.quizBuilder.key,
  ],

  modifyItems: [
    // Example: Adentis might have to modify the menu items
    // {
    //   key: "adentis-projects",
    //   label: "Projects",
    //   route: { path: "/projects", key: "projects" },
    // },
  ],
};
